module.exports = __WEBPACK_EXTERNAL_MODULE__csnext_cs_core__;